module.exports = __webpack_public_path__ + "static/media/VC.470b3aa7.png";